export default __webpack_public_path__ + "assets/audio/Godknows.5205bba3.m4a";